var _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationMark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 3,
  height: 41,
  viewBox: "0 0 3 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 38.8913,
  r: 1.5,
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  width: 2.5,
  height: 30.4348,
  rx: 1.25,
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationMark);
export { ForwardRef as ReactComponent };